import {
    useAdminConsoleApi,
    useChatApi,
    useCitationsApi,
    useCrossConcernsApi,
    useDataPackageApi,
    useDataPackageFileApi,
    useDataRequestsApi,
    useDisclosuresApi,
    useDoiApi,
    useEnquiryApi,
    useListingRequestApi,
    useMetricsApi,
    useNotificationApi,
    useOrcidApi,
    useOrganizationsApi,
    useOrgChatApi,
    useResultRequestApi,
    useStudiesApi,
    useUsersApi,
    useUtilityApi,
    useVirtualMachineApi,
    useVivliConfigApi
} from '../api';
import { IPlatformDomainHooks } from '@vivli/core/infrastructure/interface';

export const useDomainApiInit = (): IPlatformDomainHooks => {
    const usersApi = useUsersApi();
    const vivliConfigApi = useVivliConfigApi();
    const organizationsApi = useOrganizationsApi();
    const listingRequestApi = useListingRequestApi();
    const chatApi = useChatApi();
    const orgChatApi = useOrgChatApi();
    const dataRequestsApi = useDataRequestsApi();
    const disclosuresApi = useDisclosuresApi();
    const studiesApi = useStudiesApi();
    const dataPackageApi = useDataPackageApi();
    const dataPackageFileApi = useDataPackageFileApi();
    const resultRequestApi = useResultRequestApi();
    const virtualMachineApi = useVirtualMachineApi();
    const metricsApi = useMetricsApi();
    const adminConsoleApi = useAdminConsoleApi();
    const citationsApi = useCitationsApi();
    const notificationApi = useNotificationApi();
    const enquiryApi = useEnquiryApi();
    const orcidApi = useOrcidApi();
    const doiApi = useDoiApi();
    const crossConcernsApi = useCrossConcernsApi();

    // misc apis
    const utilityApi = useUtilityApi();

    // export domain apis
    return {
        usersApi,
        vivliConfigApi,
        organizationsApi,
        listingRequestApi,
        chatApi,
        orgChatApi,
        dataRequestsApi,
        disclosuresApi,
        studiesApi,
        dataPackageApi,
        dataPackageFileApi,
        resultRequestApi,
        virtualMachineApi,
        metricsApi,
        adminConsoleApi,
        citationsApi,
        notificationApi,
        enquiryApi,
        orcidApi,
        utilityApi,
        doiApi,
        crossConcernsApi
    };
};
